import { FieldTypes } from '../../constants/FieldTypes'
import { FieldMap } from '../../types/forms/fields'
import { capitalizeFirstLetterOfEachWord } from '../../utils/data'

/*
In-Network → Covered Services:

- For each of the following services, add a dropdown:
    - Coverage for {service}
        - Unlimited coverage after deductible has been met
        - Coverage with limitations after deductible has been met
        - Not Covered
    - Notes (e.g. My coverage covers 2 {service} visits after the deductible has been met)

Accupuncture
Chiropractic Services
*/
type CoveredService = 'acupuncture' | 'chiropractic' | 'physical-therapy'
const coveredServiceLabels: Record<CoveredService, string> = {
  acupuncture: 'acupuncture',
  chiropractic: 'chiropractic services',
  'physical-therapy': 'physical therapy',
}

const getCoveredServicesField = (coveredService: CoveredService): FieldMap => ({
  name: capitalizeFirstLetterOfEachWord(coveredServiceLabels[coveredService]),
  initExpanded: true,
  children: {
    serviceCoverage: {
      type: FieldTypes.DROPDOWN,
      labels: [
        {
          text: `Does my plan cover ${coveredServiceLabels[coveredService]} after the deductible has been met?`,
        },
      ],
      placeholder: 'Coverage after deductible',
      options: [
        { text: 'Unlimited coverage after deductible has been met', id: 'unlimited' },
        { text: 'Coverage with limitations after deductible has been met', id: 'limited' },
        { text: 'Not Covered', id: 'not-covered' },
      ],
    },
    notes: {
      type: FieldTypes.TEXTAREA,
      optional: true,
      hints: [
        {
          text: `i.e. My coverage covers 2 ${coveredServiceLabels[coveredService]} visits after the deductible has been met`,
        },
      ],
      placeholder: 'Service coverage notes',
    },
  },
})

const acupunctureCoverageField = getCoveredServicesField('acupuncture')
const chiropracticCoverageField = getCoveredServicesField('chiropractic')
const physicalTherapyCoverageField = getCoveredServicesField('physical-therapy')

export const coveredServicesFields: FieldMap = {
  name: 'Covered Services',
  children: {
    acupuncture: acupunctureCoverageField,
    chiropractic: chiropracticCoverageField,
    'physical-therapy': physicalTherapyCoverageField,
  },
}
